import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner";

import { DffSideModule, PageErrorModule, PanelModule, TrustHtmlModule } from "@dffedb/ui";

import { SammenlignForbrugRoutingModule } from "./sammenlign-forbrug-routing.module";
import { SammenlignForbrugComponent } from "./sammenlign-forbrug.component";

@NgModule({
    imports: [
        CommonModule,
        DffSideModule,
        MatProgressSpinnerModule,
        PageErrorModule,
        PanelModule,
        SammenlignForbrugRoutingModule,
        TrustHtmlModule
    ],
    exports: [SammenlignForbrugComponent],
    declarations: [SammenlignForbrugComponent]
})
export class EForsyningFeaturesSammenlignForbrugModule {}
